module.exports = __webpack_public_path__ + "static/media/system.92dcbfbb.svg";